// Reverting to old configurator temporarily
// export default (configurationGuid) => (
//   `/catalog/configurator/editestimate?configurationGuid=${configurationGuid}`
// );

export default (configurationGuid, pipToCart) => {
  if (pipToCart) {
    return `/catalog/stockproduct/editestimate?configurationGuid=${configurationGuid}`;
  }
  return `/catalog/configurator/editestimate?configurationGuid=${configurationGuid}`;
};
